exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".enabled_1eb877b{background-color:#52c41a}.disabled_9ff40e7,.enabled_1eb877b{display:inline-block;width:5px;height:5px;border-radius:50%;vertical-align:middle;margin-right:5px}.disabled_9ff40e7{background-color:#ff4d4f}.inputW_944e97a{width:300px!important}.textarea_8e1de9d{width:400px!important;height:200px}.textarea_8e1de9d .k-textarea{height:200px!important;resize:none}.box_b948715{padding:10px 0}.box_b948715>.img_d785eb7{width:70px;height:70px}", ""]);

// exports
exports.locals = {
	"enabled": "enabled_1eb877b",
	"disabled": "disabled_9ff40e7",
	"inputW": "inputW_944e97a",
	"textarea": "textarea_8e1de9d",
	"box": "box_b948715",
	"img": "img_d785eb7"
};